// extracted by mini-css-extract-plugin
export var attribution = "_27-4";
export var authorName = "_27-5";
export var option = "_27-g";
export var optionCard = "_27-v";
export var optionContent = "_27-w";
export var optionGrid = "_27-12";
export var optionIcon = "_27-y";
export var optionIconBox = "_27-x";
export var optionLabel = "_27-z";
export var optionList = "_27-f";
export var optionPill = "_27-13";
export var optionPillBadge = "_27-16";
export var optionPillIcon = "_27-14";
export var optionPillLabel = "_27-15";
export var optionRadio = "_27-10";
export var optionRadioInner = "_27-11";
export var optionReveal = "_27-i";
export var optionRevealDelay0 = "_27-j";
export var optionRevealDelay1 = "_27-k";
export var optionRevealDelay10 = "_27-t";
export var optionRevealDelay11 = "_27-u";
export var optionRevealDelay2 = "_27-l";
export var optionRevealDelay3 = "_27-m";
export var optionRevealDelay4 = "_27-n";
export var optionRevealDelay5 = "_27-o";
export var optionRevealDelay6 = "_27-p";
export var optionRevealDelay7 = "_27-q";
export var optionRevealDelay8 = "_27-r";
export var optionRevealDelay9 = "_27-s";
export var optionSelected = "_27-h";
export var questionsBlock = "_27-18";
export var quote = "_27-3";
export var spacer = "_27-b";
export var stepCenteredContent = "_27-9";
export var stepInner = "_27-6";
export var stepInnerFullWidth = "_27-7";
export var stepInnerLockScroll = "_27-8";
export var stepTransitionFrame = "_27-a";
export var subtitle = "_27-e";
export var testimonial = "_27-2";
export var title = "_27-c";
export var titleWithAccessory = "_27-d";
export var trustedBy = "_27-0";
export var trustedByLabel = "_27-1";
export var welcomeBlock = "_27-17";